import { render, staticRenderFns } from "./PropertyReport.vue?vue&type=template&id=d50b1c4a&scoped=true&"
import script from "./PropertyReport.vue?vue&type=script&lang=js&"
export * from "./PropertyReport.vue?vue&type=script&lang=js&"
import style0 from "./PropertyReport.vue?vue&type=style&index=0&id=d50b1c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50b1c4a",
  null
  
)

export default component.exports